import { getDefaultClient } from '../../../client/defaultClient';
import { connectWithWalletProvider } from '../connectWithWalletProvider';
import { verifyWalletAccountForSignInOrTransfer } from '../verifyWalletAccountForSignInOrTransfer';

type TransferWalletAccountParams = {
  walletProviderKey: string;
};

/**
 * Transfer a wallet account to the current user's account.
 *
 * This function requires the user to sign a message to prove wallet ownership,
 * then transfers the wallet account to the current user's account.
 *
 * @param params.walletProviderKey - The key of the wallet provider of the wallet account to transfer.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the transferred wallet account.
 */
export const transferWalletAccount = async (
  { walletProviderKey }: TransferWalletAccountParams,
  client = getDefaultClient()
) => {
  const walletAccount = await connectWithWalletProvider(
    { addToDynamicWalletAccounts: false, walletProviderKey },
    client
  );

  return verifyWalletAccountForSignInOrTransfer(
    {
      isTransfer: true,
      walletAccount,
    },
    client
  );
};
